import api from "./axiosInstance";

export const retryFailedPaymentApi = (paymentId: string) =>
  api.post(`/admin/payments/${paymentId}/retry`);

export const markPaymentAsResolvedApi = (paymentId: string, notes: string) =>
  api.patch(`/admin/payments/${paymentId}/resolve`, { notes });

export const processRefundApi = (paymentId: string, reason: string) =>
  api.post(`/admin/payments/${paymentId}/refund`, { reason });

export const markPaymentAsClosedApi = (paymentId: string) =>
  api.patch(`/admin/payments/${paymentId}/close`);

export const getPaymentWebhookLogsApi = (paymentId: string) =>
  api.get(`/admin/payments/${paymentId}/webhook-logs`);

export const getPaymentStripeDetailsApi = (paymentId: string) =>
  api.get(`/admin/payments/${paymentId}/stripe-details`);

export const getFailedPaymentsApi = (filters?: {
  page?: number;
  limit?: number;
  status?: string;
}) => api.get("/admin/payments/failed", { params: filters });
